/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("./loadMessages.js"),i=e=>{const{data:o,language:a,children:t}=e;return a&&r.loadMessages(o,a),t};exports.LocalizationDataProvider=i;
